import { graphql, useStaticQuery } from 'gatsby';
import {
    LeadershipPageData,
    LeaderCardQuery,
    ILeaderData,
} from '../LeaderPageTypes';
export const useTopLeaderCardQuery = (): {
    leader: ILeaderData;
    page: LeadershipPageData;
} => {
    const viewData = useStaticQuery<LeaderCardQuery>(graphql`
        query TopLeaderCard {
            cards: allNodeLeadershipBio(
                filter: { field_top_leadership: { eq: true } }
            ) {
                nodes {
                    title
                    field_last_name
                    field_leadership_position_title
                    field_secondary_info
                    field_top_leadership
                    field_edic
                    path {
                        alias
                    }
                    field_image {
                        alt
                    }
                    relationships {
                        field_image {
                            localFile {
                                childImageSharp {
                                    ...ImageLeaderImageCardSettings
                                }
                            }
                        }
                        field_hero_image {
                            field_media_image_1 {
                                alt
                                height
                                title
                                width
                            }
                            relationships {
                                field_media_image_1 {
                                    localFile {
                                        childImageSharp {
                                            ...ImageConstrainedSettings
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            page: nodeLandingPage(path: { alias: { eq: "/leadership" } }) {
                field_landing_page_body {
                    value
                }
                relationships {
                    field_components {
                        type: __typename
                        ... on paragraph__leadership_text_row {
                            field_text
                            field_row_number
                        }
                    }
                }
            }
        }
    `);
    const { page, cards } = viewData;
    return {
        leader: cards?.nodes?.[0],
        page,
    };
};
